<template>
  <q-dialog v-model="open" persistent @hide="isOpenSync = false">
    <q-card>
      <q-card-section>
        <h6 class="text-uppercase text-negative">Warning!</h6>
      </q-card-section>

      <q-card-section>
        <h6 class="text-uppercase text-warning">Confirm set to prohibited</h6>
      </q-card-section>

      <q-card-section>
        <p>Are you sure you want to set this RFQ to prohibited?</p>
        <p>Transporters will no longer be able to see this request.</p>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat color="muted" label="Cancel" :disable="isLoading" />
        <q-btn flat color="negative" label="Confirm" :loading="isLoading" @click="prohibitRequest" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { getErrorMessage } from '@/utils';

export default {
  props: {
    requestId: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      open: true,
    };
  },

  computed: {
    isOpenSync: {
      get() {
        return this.isOpen;
      },
      set(val) {
        return this.$emit('update:isOpen', val);
      },
    },
  },

  methods: {
    async prohibitRequest() {
      try {
        this.isLoading = true;

        const { data } = await this.$axios.delete(`/admin/rfq/${this.requestId}`);

        this.open = false;
        this.$q.notify({ message: 'RFQ successfully prohibited!', type: 'positive' });
        this.$emit('prohibited', data);
      } catch (error) {
        this.$q.notify({ message: getErrorMessage(error), type: 'negative' });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
